module.exports = __webpack_public_path__ + "static/media/platoducha.075e30c7.svg";